import axiosInstance from "./axiosInstance";

export default {
  async getProperties(query = [], page = 0, limit = 10) {
    const res = await axiosInstance.get(`/api/properties/detailed`, {
      params: {
        page: page,
        queryComplex: query,
        limit: limit
      }
    });
    return res;
  },
  async getPropertyByID(id) {
    const res = await axiosInstance.get(`/api/properties/${id}/detailed`);
    return res;
  },
  async getPropertyTypes(pagination) {
    const res = await axiosInstance.get(`/api/property-types/all`, {
      params: {
        ...pagination,
      },
    });
    return res;
  },
  async getLocalities(pagination) {
    const res = await axiosInstance.get(`/api/localities/all`, {
      params: {
        ...pagination,
      },
    });
    return res;
  },
  async getAmenities(pagination) {
    const res = await axiosInstance.get(`/api/amenities/all`, {
      params: {
        ...pagination,
      },
    });
    return res;
  },
};
